import React, { Fragment } from 'react'
import Grid from '@material-ui/core/Grid'
import Chip from '@material-ui/core/Chip'
import InputWrapper from './InputWrapper'

export default function Chips({
  label,
  id,
  items,
  error,
  isRequired = false,
  onChange,
  value,
  disabled = false,
  viewMode = false,
  forceFullLabel = false,
  align = `left`,
  type = ``,
  md = 12,
  xs = 12,
}) {
  function deleteChip(deletedValue) {
    return function eventHandler() {
      if (!viewMode) {
        const nextVal = value.filter(oldValue => deletedValue !== oldValue)
        onChange({
          name: id,
          value: nextVal,
          props: {
            hidden: nextVal.length === 0,
          },
          deletedValue,
        })
      }
    }
  }
  const selectedItems = value.map(itemValue => items.find(({ value }) => value === itemValue))
  return (
    <Fragment>
      {value.length > 0 && (
        <InputWrapper
          label={label}
          error={error}
          isRequired={isRequired}
          forceFullLabel={forceFullLabel}
          align={align}
          type={type}
          md={md}
          xs={xs}
          disabled={disabled}
          withPadding
        >
          <Grid container>
            {selectedItems.map(({ label, value }, index) => (
              <Chip
                key={`chip-${id}-${index}`}
                label={label}
                onClick={deleteChip(value)}
                clickable
              />
            ))}
          </Grid>
        </InputWrapper>
      )}
    </Fragment>
  )
}
